import { render, staticRenderFns } from "./ProductOverview.vue?vue&type=template&id=9868681e&scoped=true"
import script from "./ProductOverview.vue?vue&type=script&lang=js"
export * from "./ProductOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9868681e",
  null
  
)

export default component.exports